import Model, { attr, belongsTo } from '@ember-data/model';

export default class SystemConfiguration extends Model {
  @attr('string') systemLicense;
  @attr('string') timezone;
  @attr('string') biUrl;
  @attr('boolean', { default: true }) enableWieApprovals;

  @belongsTo('evision-config', { inverse: null, async: false, embedded: true }) evision;
  @belongsTo('jem-system-config', { inverse: null, async: false, embedded: true }) jem;
  @belongsTo('wie-config/wie', { inverse: null, async: false, embedded: true }) wie;
  @belongsTo('single-sign-on-config', { inverse: null, async: false, embedded: true }) singleSignOnConfig;
  @belongsTo('kinetic-config/kinetic', { inverse: null, async: false, embedded: true }) kinetic;

  get isDirty() {
    return super.isDirty ||
      this.evision.isDirty ||
      this.jem.isDirty ||
      this.wie.isDirty ||
      this.singleSignOnConfig.isDirty;
  }
}
